<template>
    <div class="normal">
		<div class="nav">
			<uheader />
		</div>
		<div class="view">
			<transition name="fade" mode="out-in">
			    <router-view />
			</transition>
		</div>
		
    </div> 
</template>
<script>
	import uheader from './header.vue'
	export default {
		components:{
			uheader
		},
		data () {
			return {
				activeIndex: '1',
				activeIndex2: '1'
			}
		},
		methods: {
		  handleSelect(key, keyPath) {
			console.log(key, keyPath);
		  }
		}
	}
</script>

<style scoped>
	.normal{
		display: flex;
	}
	.nav{
		width: 250px;
		height: 100vh;
		background-color: #191a23;
		overflow-y: scroll;
	}
	.view{
		flex: 1;
		height: calc( 100vh - 20px);
		padding: 10px;
		background: #f3f4f5;
		overflow-y: scroll !important;
		overflow-x: scroll !important;
		
		
	}
</style>